import { ReactNode } from 'react'
import { useTranslation } from 'next-i18next'
import useUser, { isDomainOwner, isWsAdmin, isWsAssistant } from 'shared/hooks/use-user'
import AddTopic from '../add-topic'
import { TopicList } from './components/topic-list'

export const Topics = (): ReactNode => {
  const { t } = useTranslation()
  const { user } = useUser()

  const canAddTopic = user && (isDomainOwner(user) || isWsAdmin(user) || isWsAssistant(user))

  if (!user) return null

  return (
    <div className="rounded-[10px] bg-background-secondary">
      <div className="bg-background-primary/40 px-4 py-3.5">
        <h5 className="flex items-center gap-2 text-base font-semibold text-text-primary">
          {t('sidebar.topics.title')} {canAddTopic && <AddTopic />}
        </h5>
      </div>
      <div>
        <TopicList />
      </div>
    </div>
  )
}
